import { pickupCancelledStatus, PickupStatus } from '../appConfig/enums';

/**
 * Determines the number of drivers required for a vanity trip based on the initial states and trip type.
 * @param {Object} initialStates - The initial state object containing delivery items.
 * @param {number} tripType - The type of trip, represented as a number.
 */
export const showNumberOfDrivers = (initialStates, tripType) => {
    const palletWhichHasVanity = initialStates.ItemsToDeliver.filter(data => data.isVanity);
    const noOfDrivers = (tripType === 1 || (tripType % 2 !== 0 && palletWhichHasVanity.length === tripType)) ? tripType + 1 : tripType;
    return `Large item(s) - ${noOfDrivers} drivers`
};

/**
 * Checks if the given status is a canceled or errored pickup status.
 * Uses the pickupCancelledStatus array from enums.js.
 * @param {number} status - The pickup status code.
 * @returns {boolean} True if the status is canceled or errored, otherwise false.
 */
const canceledStatuses = new Set([
    PickupStatus.PickupCancelled,
    ...pickupCancelledStatus
]);

export const isCanceledStatus = (status) => canceledStatuses.has(status);

/**
 * Checks if the trip is completed based on its progress states.
 * @param {number} status - The pickup status code.
 * @returns {boolean} True if the trip is completed, otherwise false.
 */
export const isCompletedStatus = (status) => {
    return [
        PickupStatus.Completed,
        PickupStatus.PaymentSuccessful
    ].includes(status);
};
